export const buildDevAiWorkspaceAri = (activationId: string): string => {
	return `ari:cloud:devai::workspace/${activationId}`;
};
